module.exports = __webpack_public_path__ + "img/cloud5.cd446fc0.png";